module.exports = __webpack_public_path__ + "img/video-button@3x.309a6359.png";